import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_SETTINGS } from "../lib/defaults";

let cache = DEFAULT_SETTINGS;
const subs = new Set();

export function useSiteData() {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    subs.add(setSettings);
    api.get("/public/settings").then(({ data }) => {
      cache = { ...DEFAULT_SETTINGS, ...data, images: { ...DEFAULT_SETTINGS.images, ...(data.images || {}) }, socials: { ...DEFAULT_SETTINGS.socials, ...(data.socials || {}) } };
      subs.forEach((fn) => fn(cache));
    }).catch(() => {});
    return () => subs.delete(setSettings);
  }, []);
  return settings || DEFAULT_SETTINGS;
}

export function useFetch(path, fallback = []) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get(path).then(({ data }) => { if (alive) setData(data); })
      .catch(() => {}).finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [path]);
  return { data, loading };
}

export function waLink(settings, custom) {
  const num = settings?.whatsapp || "919381205545";
  const msg = custom || settings?.whatsapp_message || "Hello Foodie Connect Caterer, I would like to enquire about catering.";
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
}
